import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function PricingSection() {
  return <section id="compra" className="bg-[#1a1a2e] py-10 md:py-16 px-4 text-white relative overflow-hidden scroll-mt-4" data-id="element-93">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-94">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-95"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-96"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-97">
        <div className="text-center mb-8" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-black mb-2 font-['Oswald'] uppercase" data-id="element-99">
            💰 Oferta especial
          </h2>
          <p className="text-gray-300" data-id="element-100">
            Todo el pack completo + bonos incluidos
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-lg mx-auto border-4 border-green-400" data-id="element-101">
          <div className="p-6 md:p-8" data-id="element-102">
            <div className="text-center mb-6" data-id="element-103">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-104">
                Antes: $ 49990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-105">
                <span className="text-xl font-bold text-gray-700" data-id="element-106">Hoy:</span>
                <span className="text-4xl md:text-5xl font-black text-[#22c55e]" data-id="element-107">
                  $ 19990
                </span>
              </div>
            </div>

            <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white text-base md:text-lg font-black py-4 px-4 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase flex items-center justify-center gap-2 animate-pulse mb-4 no-underline" data-id="element-108">
              👉 Quiero que mi hijo aprenda divirtiéndose
            </a>

            <div className="flex items-center justify-center gap-2 text-xs text-gray-500 font-medium" data-id="element-109">
              <Lock className="w-3.5 h-3.5" data-id="element-110" />
              <span data-id="element-111">Compra segura · Acceso inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}